<template>
  <div v-if="enabled && !dismissed" :style="styleObj" class="w-full" data-testid="promo-banner">
    <div class="flex items-center justify-center py-2 px-4 sm:px-6">
      <span class="flex-1 text-center text-sm font-medium">{{ text }}</span>
      <button
        @click="dismiss"
        class="flex-shrink-0 ml-4 p-1 opacity-80 hover:opacity-100 focus:outline-none transition-opacity"
        aria-label="Dismiss banner"
        title="Close"
        data-testid="promo-banner-dismiss"
      >
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
const KEY = 'promoDismissed'
const TTL_MS = 7 * 24 * 60 * 60 * 1000

function isDismissed() {
  if (typeof localStorage === 'undefined') return false
  const raw = localStorage.getItem(KEY)
  if (!raw) return false
  try {
    const { exp } = JSON.parse(raw)
    return exp && Date.now() < exp
  } catch {
    return false
  }
}

export default {
  name: 'PromoBanner',
  computed: {
    enabled() { return !!window.PROMO_BANNER_ENABLED },
    text() { return window.PROMO_BANNER_TEXT || 'Limited-time offer! Save 10% with code CAMPUS10' },
    styleObj() {
      return {
        background: window.PROMO_BANNER_BG || '#0a6a92',
        color: window.PROMO_BANNER_TEXT_COLOR || '#fff'
      }
    }
  },
  data() { return { dismissed: isDismissed() } },
  methods: {
    dismiss() {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(KEY, JSON.stringify({ exp: Date.now() + TTL_MS }))
      }
      this.dismissed = true
    }
  }
}
</script>
